import React from "react";
import { Grid, Hidden } from "@material-ui/core";
import E_ImpresaImage from "./_impresacx_img";
import E_Searchbar from "../e_searchbar/e_searchbar";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  gridSpace: {
    margin: "0px !important",
  },
  iconButton: {
    width: "20%",
    marginLeft: 5,
  },
  paddingImage:{
    paddingRight:"0px !important",
    paddingLeft:"12px !important"
  },
  imgPosition:{
    position: 'relative',
    left:'0.5rem',
      ['@media (min-width:960px)']: {
        
      left: '-3em',
      },
  },
  removeSpace:{
    paddingBottom:"0px !important"
  }
});

export default function E_ImgSearchBar({searchDisplay}) {
  let classes = useStyles();

  return (
    <Grid
      container
      spacing={5}
      justify="flex-start"
      alignItems="center"
      className={classes.gridSpace}
    >
      <Grid item className={[classes.paddingImage,classes.imgPosition]}>
        <E_ImpresaImage white={false} />
      </Grid>
      {searchDisplay && 
      <Hidden smDown>
        <Grid item className={classes.removeSpace}>
          <E_Searchbar fullWidth={false} />
        </Grid>
      </Hidden>}
    </Grid>
  );
}
